import React from 'react'
import Button from '../Button'
import S from './CallToBuy.module.css'
import FunctionsApi from '../../util/FunctionsApi'
import AccountUtil from '../../util/AccountUtil'
// WindowUtil must be implemented by client
import WindowUtil from '../../../util/WindowUtil' // eslint-disable-line import/no-unresolved, import/extensions

class CallToBuy extends React.Component {

  // props = { setLoading, email, expiredDate }
  constructor( props ) {
    super( props );
    this.state = {
      error : undefined,
    }
  }

  goToCheckoutSite = async () => {
    const { setLoading, user } = this.props;
    try {
      this.setState( { error : undefined } );
      setLoading( true, 'Opening checkout...' );
      const sessionInfo = await FunctionsApi.createCheckoutSession( user );
      await WindowUtil.openCheckoutWindow( sessionInfo ); //
    } catch ( error ) {
      console.error( 'Error creating checkout session: ', error );
      this.setState( { error : 'Checkout is currently unavailable.' } );
    } finally {
      setLoading( false );
    }
  }

  goToCustomerDashboard = async () => {
    const { setLoading, user } = this.props;
    setLoading( true, 'Opening subscription management dashboard...' );
    try {
      await FunctionsApi.goToCustomerDashboardAsync( user );
    } catch ( error ) {
      console.error( 'Error opening customer dashboard', error );
      this.setState( { error : 'The Subscription Management Dashbaord is currently unavaliable.' } );
    } finally {
      setLoading( false );
    }
  }

  getCallToActionText = () => {
    const { expiredDate, user } = this.props;
    if ( expiredDate ) {
      return (
        <>
          <p>
            Your subscription (
            <em>{user.email}</em>
            ) expired on
            {new Date( expiredDate ).toLocaleString( navigator.language, {
              weekday : 'long', month : 'short', day : 'numeric', year : 'numeric',
            } )}
            .
          </p>
        </>
      )
    }
    return (
      <>
        <p>
          Your account (
          <em>{user.email}</em>
          ) does not have an active subscription.
        </p>
      </>
    )

  }

  render() {
    const { userSignedOut } = this.props;
    const { error } = this.state;
    return (
      <div className={S.container}>
        <div className={S.titleContainer}>
          <img height="40px" src="icon-128.png" alt="" />
          <h1 className={S.title}>Script Keeper</h1>
        </div>
        <div className={S.subtitle} style={{ textAlign : 'center' }}>{this.getCallToActionText()}</div>
        <div style={{
          textAlign : 'center', color : 'red', fontWeight : 'bold', minHeight : '30px',
        }}
        >
          {error}
        </div>
        <Button scheme="primary" onClick={this.goToCheckoutSite}>Buy Subscription</Button>
        <Button scheme="primaryInverted" onClick={this.goToCustomerDashboard}>Manage Account</Button>
        <Button scheme="tertiary" onClick={() => { AccountUtil.signOut(); userSignedOut(); }}>Sign Out</Button>
      </div>
    )
  }
}

export default CallToBuy;
